import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ScenarioConditionsWidget,
  ScenarioConditionsWidgetMode,
} from '~/widgets/scenario/ScenarioConditionsWidget';

import { ClearAllButton } from './header/clear-all-button/ClearAllButton';
import * as S from './Scenario.styles';

export const Scenario = () => {
  const { t } = useTranslation('scenario');
  const [entityTags, setEntityTags] = useState<string[]>([]);

  return (
    <S.Root>
      <S.HeaderWrapper>
        <S.StyledTitle>{t('scenario:scenario')}</S.StyledTitle>
        <ClearAllButton entityTags={entityTags} setEntityTags={setEntityTags} />
      </S.HeaderWrapper>
      <ScenarioConditionsWidget
        entitiesTags={entityTags}
        mode={ScenarioConditionsWidgetMode.page}
      />
    </S.Root>
  );
};
